import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LogoGridlySVG from 'assets/images/svg/LogoGridlySVG';
import { Link } from 'react-router-dom';

const HEADER_HEIGHT = 120;

const useStyles = makeStyles(theme => ({
    root: {
        height: '100vh',
        width: '100vw'
    },
    header: {
        height: HEADER_HEIGHT,
        paddingLeft: 120,
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 20
        }
    },
    content: {
        height: `calc(100vh - ${HEADER_HEIGHT}px)`
    }
}));

function CantAccessLayout({ children }) {
    const classes = useStyles();

    return (
        <Grid container className={classes.root} direction="column">
            <Grid item className={classes.header} container alignItems="center" direction="row">
                <Grid item>
                    <Link to="/">
                        <LogoGridlySVG />
                    </Link>
                </Grid>
            </Grid>
            <Grid item className={classes.content}>
                {children}
            </Grid>
        </Grid>
    );
}

export default CantAccessLayout;
